
import data_view_pb from "@/proto/data_view_pb.js";
/**
 * 获取dataview中的枚举值
 * @param {*} typeName 
 * @param {*} enumValue 
 * @returns 
 */
export function getDataViewEnum_PlanningTrafficLightPurpose(value) {
    for (let key in data_view_pb.PlanningTrafficLight.Purpose) {
        if (data_view_pb.PlanningTrafficLight.Purpose[key] == value) {
            return key;
        }
    }
    return 'unknown';
}
export function getDataViewEnum_PlanningTrafficLightStateSource(value) {
    for (let key in data_view_pb.PlanningTrafficLight.StateSource) {
        if (data_view_pb.PlanningTrafficLight.StateSource[key] == value) {
            return key;
        }
    }
    return 'unknown';
}
//proto.zelos.zoe.data_view.proto.VehicleData.LocStatus
export function getEnumName_LocStatus(value) {
    for (let key in data_view_pb.VehicleData.LocStatus) {
        if (data_view_pb.VehicleData.LocStatus[key] == value) {
            return key;
        }
    }
    return 'unknown';
}
//proto.zelos.zoe.data_view.proto.PlanningTrafficLight.Purpose
export function getEnumName_PlanningTrafficLight_Purpose_all() {
    let nameList = [];
    for (let key in data_view_pb.PlanningTrafficLight.Purpose) {
        nameList.push(key)
    }
    return nameList;
}

export function getEnumName_LocMode(value) {
    for (let key in data_view_pb.VehicleData.LocMode) {
        if (data_view_pb.VehicleData.LocMode[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_AnomalySeverity(value) {
    if (value == 99) {
        return null;
    }
    for (let key in data_view_pb.VehicleData.AnomalySeverity) {
        if (data_view_pb.VehicleData.AnomalySeverity[key] == value) {
            let arr = key.split('_');
            if (arr.length > 1) {
                return arr[1]
            }else{
                return arr[0]
            }
        }
    }
    return 'unknown';
}

export function getEnumName_AnomalySeverity2(value) {
    if (value == 99) {
        return null;
    }
    for (let key in data_view_pb.VehicleData.AnomalySeverity) {
        if (data_view_pb.VehicleData.AnomalySeverity[key] == value) {
            let arr = key.split('_');
            if (arr.length > 1) {
                return arr[1]
            }else{
                return arr[0]
            }
        }
    }
    return 'unknown';
}
export function getEnumName_RoadType(value) {
    for (let key in data_view_pb.RoadType) {
        if (data_view_pb.RoadType[key] == value) {
            return key;
        }
    }
    return 'unknown';
}
export function getEnumName_LocalizationSourceFrom(value) {
    for (let key in data_view_pb.Localization.SourceFrom) {
        if (data_view_pb.Localization.SourceFrom[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_LocalizationRoadType(value) {
    for (let key in data_view_pb.Localization.RoadType) {
        if (data_view_pb.Localization.RoadType[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_LocalizationMode(value) {
    for (let key in data_view_pb.Localization.Mode) {
        if (data_view_pb.Localization.Mode[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_LocalizationStatus(value) {
    for (let key in data_view_pb.Localization.Status) {
        if (data_view_pb.Localization.Status[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_GpsInfo_GnssStatus(value) {
    for (let key in data_view_pb.GpsInfo.GnssStatus) {
        if (data_view_pb.GpsInfo.GnssStatus[key] == value) {
            return key;
        }
    }
    return 'unknown';
}

export function getEnumName_GpsInfo_GpsPositionStatus(value) {
    for (let key in data_view_pb.GpsInfo.GpsPositionStatus) {
        if (data_view_pb.GpsInfo.GpsPositionStatus[key] == value) {
            return key;
        }
    }
    return 'unknown';
}


export function get_SpeedLimitSource_name(value) {
    for (let key in data_view_pb.SpeedLimitStatus.SpeedLimitSource) {
        if (data_view_pb.SpeedLimitStatus.SpeedLimitSource[key] == value) {
            return key;
        }
    }
    return value;
}